'use es6';

import { defaultNamespace } from './getSuperstoreClient';
export const getSuperstoreKey = keyPart => `${defaultNamespace}:${keyPart}`;